import React, {useContext} from "react";
import "./Footer.scss";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="5px">
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {emoji("Made with ❤️ by JoaoDiasDev")}
          <img className="footer-logo" alt="Joao Dias Dev Logo" src={require("../../assets/images/joaoDiasDevLogoNoBg.png")}
          width={"120px"} height={"auto"}></img>
        </p>
      </div>
    </Fade>
  );
}
